var map = {
	"./A-stab.mp3": 5911,
	"./As-stab.mp3": 8896,
	"./B-stab.mp3": 811,
	"./C-stab.mp3": 3173,
	"./Cs-stab.mp3": 4665,
	"./D-stab.mp3": 6999,
	"./Ds-stab.mp3": 7139,
	"./E-stab.mp3": 9868,
	"./F-stab.mp3": 6915,
	"./Fs-stab.mp3": 9572,
	"./G-stab.mp3": 3292,
	"./Gs-stab.mp3": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2528;